import React from 'react';
import { Typography } from '@material-ui/core';
import UserTableBlankBase from './UserTableBlankBase';
import TotalError from '../static/TotalErrorState';
export function LicenseComplianceTotalErrorState() {
    return (React.createElement(UserTableBlankBase, { image: React.createElement(TotalError, null), message: React.createElement("div", null,
            React.createElement(Typography, { variant: "h2", gutterBottom: true }, "Unable to load this page"),
            React.createElement(Typography, { variant: "subtitle1" }, "Check the network connection."),
            React.createElement(Typography, { variant: "subtitle1" }, "You may also refresh the page or try again later.")) }));
}
//# sourceMappingURL=LicenseComplianceTotalErrorState.js.map